/**
 * A surface, as a screen prints it — slice 44.
 *
 * `SURFACE_CAPABILITY[surface].label` is the only string a screen may print
 * for a surface (see `@wend/shared`'s `surface.ts`), and these three functions
 * are the only way this app's screens reach it: a surface, a campaign's
 * channel and a Meta placement each become their label here, so the campaigns
 * list, the campaign's page, Analytics, the report picker and the ad panels
 * cannot name one surface two ways. (The API's workbook names its sheets from
 * the same taxonomy on its own side, and its "Other placements" sheet is the
 * same words as {@link placementLabel}'s.)
 *
 * A placement that is no surface — Audience Network, Messenger and whatever
 * Meta adds, folded into `other` — is printed as what it is. Its spend is
 * real, and a label that folded it into Facebook would move money between
 * surfaces on the screen.
 */
import {
  SURFACE_CAPABILITY,
  surfaceOfChannel,
  surfaceOfPlacement,
  type Channel,
  type MetaPlacement,
  type Surface,
} from '@wend/shared';

export function surfaceLabel(surface: Surface): string {
  return SURFACE_CAPABILITY[surface].label;
}

/** The surface a campaign on this channel is on, as its label. */
export function channelSurfaceLabel(channel: Channel): string {
  return surfaceLabel(surfaceOfChannel(channel));
}

/** A Meta placement: its surface's label, or "Other placements". */
export function placementLabel(placement: MetaPlacement): string {
  const surface = surfaceOfPlacement(placement);
  return surface === null ? 'Other placements' : surfaceLabel(surface);
}
